<template>
  <div class="component availability-calendar input-item">
    
    <span class="icon date" v-if="!inline"></span>

    <datepicker :inline="inline" :disabledDates="disabledDates" :language="languages[$i18n.locale]" v-model="modelValue" @changedMonth="changedMonth"></datepicker>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import AvailabilityDay from '@/models/AvailabilityDay';
import moment from 'moment';
import {en, es, fr, it, ptBR, ja, de, nbNO, ar, ru, zh, he, ko} from 'vuejs-datepicker/dist/locale'

// OLD datepicker markup <datepicker :inline="true" :highlighted="highlightedDates" :disabledDates="disabledDates" :dayCellContent="dayCell" @changedMonth="changedMonth" v-model="modelValue"></datepicker>

export default {
  data () {

    return {
      languages:{
        "ar-AE": ar,
        "de-DE": de,
        "en-US": en,
        "es-ES": es,
        "fr-CA": fr,
        "fr-FR": fr,
        "he-IL": he,
        "it-IT": it,
        "ja-JP": ja,
        "ko-KR": ko,
        "nb-NO": nbNO,
        "pt-PT": ptBR,
        "ru-RU": ru,
        "zh-CHT": zh,
        "zh-CN": zh
      }
    }
  },
  // we want to show prices when the context is for a specific Activity
  // we want to show number of activities when the context is for a category
  components: {
    Datepicker
  },

  props: {
    value: Date,
    category: Number,
    activity: Number,
    enabled: Array,
    inline: {
      type: Boolean,
      default: true
    },
    unavailabilities: Array
  },

  created() {
    if (this.category) {
      // AvailabilityDay.fetchMonth(moment().format('YYYY-MM'), this.category).then(() => {
      //   if (this.value) {
      //     this.daySelected(this.value);
      //   }
      // });
    }

  },

  computed: {


    highlightedDates() {
      return {
        // days: [3]
      }
    },

    disabledDates() {
      let disabledDates = { to: moment().startOf('day').toDate(), dates: []};
      if (this.unavailabilities !== undefined){
        this.unavailabilities.forEach(d =>{
          disabledDates.dates.push(moment(d).toDate());
        });
      }

      if (this.enabled !== undefined) {
        let enabled = this.enabled;
        disabledDates.customPredictor = function(date) {
          let disabled = true;
          let now = moment(date);

          if (enabled) {
            disabled = true;
            enabled.forEach(item => {
              disabled &= !(now.isSameOrAfter(item.from) && now.isSameOrBefore(item.to) && item.days[now.format('dddd').toLowerCase()]);
            });
          }

          return disabled;
        }
      }

      return disabledDates;
    },

    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  methods: {
    dayCell(day) {
      let meta = '';

      if (this.category) {
        let date = moment(new Date(day.timestamp));
        let id = `${this.category}-${date.format('YYYY-MM-DD')}`;
        let obj = AvailabilityDay.find(id);
        let count = obj ? obj.count : 0;
        meta = `<div class="day-meta">${count}</div>`;
      }

      return `${day.date}${meta}`;
    },

    daySelected(date) {
    },

    changedMonth(date) {
        this.$emit('changedMonth', date);
    }
  }
}
</script>

<style lang="scss">

.component.availability-calendar {
  .icon {
    color: $colorDarkGray;
    font-size: 20px;
    line-height: 50px !important;
    width: 25px;
    min-width: 25px;
    margin-right: 15px;
    text-align: center;
    @include breakpoint(medium) {
      color: $colorGray;
      position: absolute;
      line-height: 45px !important;
      z-index: 1;
      margin-left: 10px;
      font-size: 18px;
    }

    &.guest {
      @include font-awesome($fa-var-user, light);
    }
  }
  .date.icon { @include font-awesome($fa-var-calendar-alt, light); }
  display: flex;
  margin-bottom: 25px;
  .vdp-datepicker {
    width: 100%;
  }
  .vdp-datepicker input{
    @include breakpoint(medium) {
      padding-left: 40px;
    }
  }
  .vdp-datepicker__calendar {
    width: 100%;
    border: none;
    padding-bottom: 10px;

    @include breakpoint(medium) {
      padding: 12px;
      border: 1px solid $colorPaleGray;
      border-radius: 4px;
    }

    header {
      @include breakpoint(medium) {
        line-height: 30px;
      }

      .prev, .next {
        &::after {
          font-size: 18px;
          text-indent: 0;
          border: none;
          margin: 0;
          color: $colorBlue;
        }
        &.disabled::after {
          color: $colorPaleGray;
        }
      }

      .prev::after { @include font-awesome-pseudo($fa-var-chevron-left, light); }
      .next::after { @include font-awesome-pseudo($fa-var-chevron-right, light); }

      .prev:not(.disabled):hover,
      .next:not(.disabled):hover,
      .up:not(.disabled):hover {
        background-color: $colorPaleBlueGray;
      }

      span {
        font-size: 15px;
        font-weight: 500;
        border-radius: 3px;
      }
    }


    .cell {
      border-radius: 3px;
      position: relative;
      border-color: transparent !important;
      transition: background-color .2s;
      //line-height: 28px;  // if we are using day-meta (which we ripped out for now)

      @include breakpoint(medium) {
        height: 32px;
        line-height: 32px;
      }

      &.day-header {
        font-size: 90%;
        color: $colorGray;
      }

      &:not(.blank):not(.disabled):not(.day-header) {
        color: $colorBlue;

        &:not(.selected):hover {
          background-color: $colorPaleBlueGray;
        }

        &.selected {
          background-color: $colorBlue;
          color: white;
        }
      }

      &.selected.disabled {
        background-color: $colorPaleBlueGray;
      }
    }
  }
}
</style>